package pl.decks.chartjs.silk.radar

import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.model.JSScriptableIndexable
import pl.decks.chartjs.radar.RadarConfig
import pl.decks.chartjs.radar.options.RadarScaleOptions
import pl.decks.chartjs.radar.options.AngleLineOptions
import pl.decks.chartjs.radar.options.GridOptions
import pl.decks.chartjs.radar.options.PointLabelOptions
import pl.decks.chartjs.radar.options.TickOptions
import pl.decks.chartjs.radar.options.plugins.LegendLabelOptions
import pl.decks.chartjs.radar.options.plugins.LegendOptions
import pl.decks.chartjs.radar.options.plugins.RadarPluginOptions
import pl.decks.chartjs.silk.color.toChartColor

internal fun RadarConfig.withSilkDefaults(defaults: SilkRadarDefaults): RadarConfig {
    val currentScale = options.scale ?: RadarScaleOptions()
    val currentPlugins = options.plugins ?: RadarPluginOptions()
    val currentLegend = currentPlugins.legend ?: LegendOptions()
    val currentLabels = currentLegend.labels ?: LegendLabelOptions()

    return copy(
        options = options.copy(
            scale = currentScale.copy(
                backgroundColor = currentScale.backgroundColor ?: defaults.chartBackgroundColor.toChartColor(),
                grid = (currentScale.grid ?: GridOptions()).copy(
                    color = currentScale.grid?.color
                        ?: JSScriptableIndexable.Static(defaults.gridColor.toChartColor()),
                ),
                ticks = (currentScale.ticks ?: TickOptions()).copy(
                    color = currentScale.ticks?.color
                        ?: JSScriptable.Static(defaults.tickColor.toChartColor()),
                    backdropColor = currentScale.ticks?.backdropColor
                        ?: JSScriptable.Static(defaults.backdropColor.toChartColor()),
                ),
                angleLines = (currentScale.angleLines ?: AngleLineOptions()).copy(
                    color = currentScale.angleLines?.color
                        ?: JSScriptableIndexable.Static(defaults.angleLinesColor.toChartColor()),
                ),
                pointLabels = (currentScale.pointLabels ?: PointLabelOptions()).copy(
                    color = currentScale.pointLabels?.color
                        ?: JSScriptableIndexable.Static(defaults.pointLabelColor.toChartColor()),
                ),
            ),
            plugins = currentPlugins.copy(
                legend = currentLegend.copy(
                    labels = currentLabels.copy(
                        color = currentLabels.color
                            ?: JSScriptable.Static(defaults.legendLabelColor.toChartColor()),
                    )
                )
            )
        )
    )
}
